// extracted by mini-css-extract-plugin
export default {"add-button":"addbutton_add-button__5zf9Y","content":"addbutton_content__J+ErZ","icon":"addbutton_icon__qMsTY"};